import React from 'react';
import { Visitor, ActiveSubscriptionInfo } from '@gym-management/shared';
import CompactMode from './modes/CompactMode';
import NormalMode from './modes/NormalMode';
import FullMode from './modes/FullMode';
import TableMode from './modes/TableMode';

export interface VisitorCardProps {
  visitor: Visitor;
  mode?: 'compact' | 'normal' | 'full' | 'table';
  onEdit?: (visitor: Visitor) => void;
  onDelete?: (id: string) => void;
  onShowQR?: (visitor: Visitor) => void;
  onShowHistory?: (visitor: Visitor) => void;
  onViewDetails?: (visitor: Visitor) => void;
  onCheckIn?: () => void;
  onCheckOut?: () => void;
  isCheckedIn?: boolean;
  hasActiveSubscription?: boolean; // для обратной совместимости
  activeSubscription?: ActiveSubscriptionInfo; // детальная информация о подписке
  size?: 'small' | 'medium';
}

const VisitorCard: React.FC<VisitorCardProps> = (props) => {
  const {
    mode = 'normal',
    isCheckedIn = false,
    hasActiveSubscription,
    activeSubscription,
    size = 'medium',
    ...rest
  } = props;

  if (mode === 'table') {
    return (
      <TableMode
        {...rest}
        isCheckedIn={isCheckedIn}
        hasActiveSubscription={hasActiveSubscription}
        activeSubscription={activeSubscription}
        size={size}
      />
    );
  }

  switch (mode) {
    case 'compact':
      return (
        <CompactMode
          {...rest}
          isCheckedIn={isCheckedIn}
          hasActiveSubscription={hasActiveSubscription}
          activeSubscription={activeSubscription}
        />
      );
    case 'full':
      return (
        <FullMode
          {...rest}
          isCheckedIn={isCheckedIn}
          hasActiveSubscription={hasActiveSubscription}
          activeSubscription={activeSubscription}
        />
      );
    case 'normal':
    default:
      return (
        <NormalMode
          {...rest}
          isCheckedIn={isCheckedIn}
          hasActiveSubscription={hasActiveSubscription}
          activeSubscription={activeSubscription}
        />
      );
  }
};

export default VisitorCard;
